<template>
  <div class="settings">
    <h1>Settings</h1>
    <div class="row">
      <div class="col-md-4 mt-3">
        <div class="box setting-box">
          <div class="wrap">
            <h2>Coach Tour Settings</h2>
            <router-link class="button p-3 animated-btn" to="/settings/regions">Manage Regions</router-link>
            <router-link class="button p-3 animated-btn" to="/settings/points">Manage Pickup Points</router-link>
          </div>
        </div>
      </div>
      <div class="col-md-4 mt-3">
        <div class="box setting-box">
          <div class="wrap">
            <h2>Manage Brochures</h2>
            <router-link class="button p-3 animated-btn" to="/settings/brochures">Manage Brochures</router-link>
          </div>
        </div>
      </div>
      <div class="col-md-4 mt-3">
        <div class="box setting-box">
          <div class="wrap">
            <h2>Manage System Settings</h2>
            <router-link class="button p-3 animated-btn" to="/settings/system">Manage System Settings</router-link>
          </div>
        </div>
      </div>
      <div class="col-md-4 mt-3">
        <div class="box setting-box" v-if="userRole == 1">
          <div class="wrap">
            <h2>Manage Admin Users</h2>
            <router-link class="button p-3 animated-btn" :to="{name: 'admin-user-index'} ">Manage Admin Users</router-link>
          </div>
        </div>
      </div>
      <div class="col-md-4 mt-3">
        <div class="box setting-box">
          <div class="wrap">
            <h2>Manage Currency</h2>
            <router-link class="button p-3 animated-btn" :to="{name: 'currency-exchange-index'} ">Manage Currency Exchange Rates</router-link>
          </div>
        </div>
      </div>
      <div class="col-md-4 mt-3">
        <div class="box setting-box">
          <div class="wrap">
            <h2>Backup Management System</h2>
            <router-link class="button p-3 animated-btn" :to="{name: 'backups-list'} ">Manage DB Backups</router-link>
          </div>
        </div>
      </div>
      <div class="col-md-4 mt-3">
        <div class="box setting-box">
          <div class="wrap">
            <h2> Monthly Accounting Management </h2>
            <router-link class="button p-3 animated-btn" :to="{name: 'monthly-accounts'} ">Manage Monthly Accounting</router-link>
          </div>
        </div>
      </div>
      <div class="col-md-4 mt-3">
        <div class="box setting-box">
          <div class="wrap">
            <h2> Manage Third Party API's </h2>
            <router-link class="button p-3 animated-btn" :to="{name: 'third-party-api'} "> Manage </router-link>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'settings',
  data() {
    return {
      userRole : localStorage.getItem("user_role")
    }
  }
}
</script>

<style scoped>
.setting-box {
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.setting-box:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0,0,0,0.1);
}

.setting-box h3 {
  margin-bottom: 1rem;
  color: #333;
}

.button-group {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.animated-btn {
  background: linear-gradient(135deg, #ff5e57, #ff9966);
  border: none;
  color: white;
  padding: 10px 14px;
  font-size: 0.9rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(255, 94, 87, 0.3);
}

.animated-btn:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 10px rgba(255, 94, 87, 0.4);
  background: linear-gradient(135deg, #ff9966, #ff5e57);
}
</style>
